import { YearContext, YearContextType } from '../context/YearContext';
import { useContext } from 'react';

export const useYearContext = (): YearContextType => {
    const context = useContext(YearContext);
    
    if (!context) {
        throw Error('useYearContext must be used inside a YearContextProvider');
    }
    
    return context;
};
